import { useIntl } from 'react-intl';
import type { UseFormReturn } from 'react-hook-form';
import type { FieldConfig } from '../field';

export const ADDRESS_FIELD = 'address';

export function useAddressAutocompleteField(
    form: UseFormReturn<{ [ADDRESS_FIELD]: string }>,
): FieldConfig {
    const {
        control,
        formState: { errors },
    } = form;
    const intl = useIntl();

    return {
        id: 'address-field',
        name: ADDRESS_FIELD,
        helpText: 'e.g. 1576 Atha Drive',
        label: intl.formatMessage({
            id: 'address.field.label',
            defaultMessage: 'Street Address',
        }),
        type: 'autocomplete',
        rules: {},
        error: errors[ADDRESS_FIELD],
        variant: 'new-style',
        autoFocus: true,
        autoComplete: 'off',
        control,
    };
}
